import React from 'react';
import { MapPin } from 'lucide-react';
import ambulancePng from '../../svg/Rectangle.png';

const LegendItem = ({ icon, label }) => (
  <div className="flex items-center gap-1.5">
    <span className="flex items-center justify-center w-5 h-5 shrink-0">{icon}</span>
    <span className="text-xs text-gray-600 font-medium whitespace-nowrap">{label}</span>
  </div>
);

// Compact single-row legend rendered below the map (not an overlay on top of
// it) — matches the blue pickup pin and native red drop-off pin so the legend
// and the actual markers on the map always agree.
const CommandCenterMapLegend = ({ showPatient = false }) => (
  <div className="flex items-center justify-center gap-4 sm:gap-6 flex-wrap px-4 py-2.5 border-t border-gray-100 bg-gray-50/60">
    <LegendItem icon={<MapPin className="w-4 h-4 text-blue-600" fill="currentColor" />} label="Pickup" />
    <LegendItem icon={<MapPin className="w-4 h-4 text-red-600" fill="currentColor" />} label="Drop-off" />
    <LegendItem icon={<img src={ambulancePng} className="w-5 h-4 object-contain" alt="" />} label="Driver" />
    {showPatient && (
      <LegendItem icon={<span className="inline-block w-3.5 h-3.5 rounded-full bg-teal-700 border-2 border-white shadow" />} label="Patient (shared)" />
    )}
    <LegendItem icon={<span className="inline-block w-4 h-1 rounded-full bg-[#EF4444]" />} label="Planned Route" />
    <LegendItem icon={<span className="inline-block w-4 h-1 rounded-full bg-[#1A73E8]" />} label="Actual Route" />
  </div>
);

export default CommandCenterMapLegend;
